module.exports = __webpack_public_path__ + "img/layout_horizontal_right.de9d07e8.svg";